import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgentListTabComponent } from 'components/queue-view/live-workload-tab/agent-list-tab/agent-list-tab.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { ModalDialogModule } from 'shared/components/modal-dialog/modal-dialog.module';
import { SkeletonLoaderModule } from 'shared/components/skeleton-loader/skeleton-loader.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LiveWorkloadTabComponent } from './live-workload-tab.component';
import { DepartmentListTabComponent } from './department-list-tab/department-list-tab.component';
import { VisibilityObserverDirective } from 'shared/directives/visibility-observer/visibility-observer.directive';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { InfoLabelModule } from 'shared/components/info-label/info-label.module';

@NgModule({
  imports: [
    CommonModule,
    MatCheckboxModule,
    SvgIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    TranslateModule.forChild(),
    LoadingModule,
    ModalDialogModule,
    SkeletonLoaderModule,
    ScrollingModule,
    CustomPipesModule,
    TooltipModule,
    InfoLabelModule
  ],
  declarations: [
    AgentListTabComponent,
    LiveWorkloadTabComponent,
    DepartmentListTabComponent,
    VisibilityObserverDirective
  ],
  exports: [
    LiveWorkloadTabComponent
  ]
})
export class LiveWorkloadTabModule {}
